/**
 * A special file path for the workspace context file.
 */
export const WORKSPACE_CONTEXT_FILE_PATH = "hex.md" as const;
